<template>
  <div class="card-shirt">
    <div class="card-bodyshirt">
      <img :src="getKidImgUrl(kid.image)" alt="shirt">
      <form class="form">
        <p class="title">{{ kid.name }}</p>
        <p class="descript">{{ kid.description }}</p>
        <div class="row margin">
          <p class="cell">${{ kid.price.USD }}</p>
          <s class="cell grey">${{ kid.price.NOK }}</s>
          <p class="cell col">-{{ findpercent(kid.price.USD, kid.price.NOK) }}%</p>
        </div>
        <div class="row">
          <div class="cell-shirt">
            <p class="quantity">Quantity:</p>
          </div>
          <label for="cell-shirt">
            <input class="input" type="number" v-model="numb">
          </label>
        </div>
        <div class="cell">
          <button @click="addToCart(kid.name, numb)" type="button" class="btn btn-light">
            Add to cart
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: ['kid', 'index', 'addToCart', 'getKidImgUrl', 'findpercent'],
  data() {
    return {
      numb: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.card-shirt {
  display: flex;
  flex-direction: column;
  max-width: 100%;
  align-items: center;
  padding: 4% 8% 0 8%;
}

.card-bodyshirt {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #e5e4ec;
  width: 100%;
  padding-bottom: 4%;
  box-shadow: 0px 5px 8px rgba(0,0,0,.3);
}

.form {
  display: flex;
  background-color: #e5e4ec;
  flex-direction: column;
  width: 100%;
  padding-bottom: 4%;
}

.title {
  font-size: 1.5em;
  font-weight: 600;
}

.row-shirt {
  margin: 1% 0 0 0;
}

.descript {
  text-align: center;
  margin: 2% 0 0 0;
}

.cell {
  text-align: center;
  margin: 2% 0 0 0;
  font-weight: 700;
}

.cell-shirt {
  margin-right: 4%;
}

.row {
  display: flex;
  flex-direction: row;
}

.col {
  color: rgb(228, 82, 82);
}

.grey {
  color: rgb(149, 144, 144);
}

.margin {
  margin: 2% 0 2% 0;
}

.quantity {
  margin: 0 1% 0 0;
  font-weight: 600;
}

.input {
  width: 80%;
}

</style>
